var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 52.916665 52.916666",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f92d0",
      strokeWidth: 0.228639,
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "rect1",
    width: 13.737459,
    height: 12.513882,
    x: 1.2684807,
    y: 34.038231
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f92d0",
      strokeWidth: 0.228639,
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "rect1-6",
    width: 13.737459,
    height: 12.513882,
    x: 19.86253,
    y: 34.029774
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f92d0",
      strokeWidth: 0.228639,
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "rect1-6-0",
    width: 13.737459,
    height: 12.513882,
    x: 19.842245,
    y: 7.5433888
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f92d0",
      strokeWidth: 0.228639,
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "rect1-9",
    width: 13.737459,
    height: 12.513882,
    x: 38.336826,
    y: 34.041672
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f92d0",
      strokeWidth: 0.711044,
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "rect2",
    width: 0.41712934,
    height: 10.390023,
    x: 26.66271,
    y: 21.203375
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f92d0",
      strokeWidth: 0.520518,
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "rect2-8",
    width: 0.41712934,
    height: 5.5679512,
    x: 8.2722969,
    y: 25.715385
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f92d0",
      strokeWidth: 0.520518,
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "rect2-8-2",
    width: 0.41712934,
    height: 5.5679512,
    x: 45.326595,
    y: 25.692392
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2f92d0",
      strokeWidth: 1.53561,
      fillOpacity: 1,
      fillRule: "nonzero"
    },
    id: "rect2-3",
    width: 0.53988254,
    height: 37.442116,
    x: 25.638647,
    y: -45.704597,
    transform: "rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchyBlue);
export default __webpack_public_path__ + "static/media/hierarchy_blue.ab19391c9bbbbf89c1ab6b2e5ae5d22a.svg";
export { ForwardRef as ReactComponent };